import { React, useState, useEffect } from 'react';
import { Avatar, Box, Button, Select, MenuItem, TextField, Typography, FormControl, InputLabel, Input } from '@mui/material';
import { AddNewPostBox, AddNewPostContainer } from '../../styles/optionsStyled';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios';



const AddNewPost = ({ changeEditPost, postId }) => {

    const [editorValue, setEditorValue] = useState('');
    const [title, setTitle] = useState("")
    const [category, setCategory] = useState('');
    const [image, setImage] = useState(null);
    const [status, setStatus] = useState('');

    const handleEditorChange = (content) => {
        setEditorValue(content);
    };

    useEffect(() => {
        fetchSinglePostData(postId)
    }, [postId])

    const fetchSinglePostData = async (postId) => {
        try {
            const apiResponse = await axios.get(
                `https://www.top500ai.com/top500ai_wordpress/wp-json/wp/v2/posts/${postId}`);

            console.log(apiResponse.data);
        } catch (error) {
            console.error(error);
        }
    }

    const handleImageChange = (event) => {
        const file = event.target.files[0]; // Get the selected file
        if (file) {
            setImage(URL.createObjectURL(file)); // Create a local URL for the file
        }
    };

    const modules = {
        toolbar: [
            [{ 'size': ['small', 'normal', 'large', 'huge'] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['bold', 'italic', 'underline'],
            [{ 'align': [] }],
            ['link', 'image'],
            ['clean']
        ]
    };


    return (
        <AddNewPostBox>
            <AddNewPostContainer maxWidth='sm'>
                <Typography variant='h6' sx={{ width: '100%', marginTop: '30px' }}>Edit Post</Typography>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                    <TextField id="title-post" value={title} label="Title" variant="outlined" color='info' size='medium' sx={{ minWidth: '35%' }} onChange={(e) => setTitle(e.target.value)} />
                    <FormControl sx={{ minWidth: "35%" }} size="medium">
                        <InputLabel id="demo-select-small-label" color='info'>Category</InputLabel>
                        <Select
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={category}
                            label="Category"
                            onChange={(e) => setCategory(e.target.value)}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            <MenuItem value="ai-blog">ai-blog</MenuItem>
                            <MenuItem value="ai-tool">ai-tool</MenuItem>
                            <MenuItem value="ai-trader">ai-trader</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
                <ReactQuill
                    value={editorValue}
                    onChange={handleEditorChange}
                    theme="snow"
                    modules={modules}
                />
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '40px' }}>
                    <Box >
                        <Typography>Featured Image</Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Input
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange}
                                style={{ display: 'none' }}
                                inputProps={{ id: 'file-input' }}
                            />
                            <label htmlFor="file-input">
                                <Button variant="contained" color="info" component="span">
                                    Choose File
                                </Button>
                            </label>

                            {/* Image preview using Material-UI Avatar */}
                            {image && (
                                <Box >
                                    <Avatar
                                        alt="Selected Image"
                                        variant="square"
                                        src={image}
                                        sx={{ width: 300, height: 150, marginTop: '10px' }}
                                    />
                                </Box>
                            )}
                        </Box>
                    </Box>
                    <FormControl sx={{ minWidth: "35%" }} size="medium">
                        <InputLabel id="demo-select-small-label" color='info'>Status</InputLabel>
                        <Select
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={status}
                            label="Status"
                            onChange={(e) => setStatus(e.target.value)}
                        >
                            <MenuItem value="Active">Active</MenuItem>
                            <MenuItem value="Draft">Draft</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end', gap: "10px", marginBottom: '30px' }}>
                    <Button onClick={changeEditPost} variant='contained' color='error'> Cancel</Button>
                    <Button onClick={changeEditPost} variant='contained' color='success' >Submit</Button>
                </Box>

            </AddNewPostContainer>

        </AddNewPostBox >
    )
}

export default AddNewPost